import TokensApi from '../../core/api/TokensApi'
import AdministratorsApi from '../../core/api/AdministratorsApi'
export const FETCHED_RESET_TOKEN_VERIFICATION = 'FETCHED_RESET_TOKEN_VERIFICATION'
export const FETCHING_RESET_TOKEN_VERIFICATION = 'FETCHING_RESET_TOKEN_VERIFICATION'
export const ADMINISTRATION_UPDATE_PASSWORD_SUBMITTING = 'ADMINISTRATION_UPDATE_PASSWORD_SUBMITTING'
export const ADMINISTRATION_UPDATE_PASSWORD_SUBMITTED = 'ADMINISTRATION_UPDATE_PASSWORD_SUBMITTED'
export const ADMINISTRATION_UPDATE_PASSWORD_SET_NEW_PASSWORD = 'ADMINISTRATION_UPDATE_PASSWORD_SET_NEW_PASSWORD'
export const ADMINISTRATION_UPDATE_PASSWORD_SET_CONFIRMED_PASSWORD = 'ADMINISTRATION_UPDATE_PASSWORD_SET_CONFIRMED_PASSWORD'

export const setNewPassword = (newPassword) => ({
  type: ADMINISTRATION_UPDATE_PASSWORD_SET_NEW_PASSWORD,
  newPassword: newPassword
})

export const setConfirmedPassword = (confirmedPassword) => ({
  type: ADMINISTRATION_UPDATE_PASSWORD_SET_CONFIRMED_PASSWORD,
  confirmedPassword: confirmedPassword
})

export const fetchingResetTokenVerification = (token) => ({
  type: FETCHING_RESET_TOKEN_VERIFICATION,
  token
})

export function fetchResetTokenVerification (token) {
  const api = new TokensApi()
  const request = api.verifyResetToken(token)

  return (dispatch) => {
    dispatch(fetchingResetTokenVerification(token))
    request.then(function (response) {
      dispatch(api.handleResponse(FETCHED_RESET_TOKEN_VERIFICATION, response))
    })
  }
}

export const updatingPassword = () => ({
  type: ADMINISTRATION_UPDATE_PASSWORD_SUBMITTING
})

export function updatePassword (resetToken, newPassword, confirmedPassword) {
  const api = new AdministratorsApi()
  const request = api.updatePassword(resetToken, newPassword, confirmedPassword)

  return (dispatch) => {
    dispatch(updatingPassword())
    request.then(function (response) {
      dispatch(api.handleResponse(ADMINISTRATION_UPDATE_PASSWORD_SUBMITTED, response))
    })
  }
}
